import { FC } from 'react';
import AreaManagerSelect from './AreaManagerSelect';
import UseAreaManagerSelect from './UseAreaManagerSelect';

const AreaManagerSelectContainer: FC = () => {
  return <AreaManagerSelect {...UseAreaManagerSelect()} />;
};

export default AreaManagerSelectContainer;
